import Vue from 'vue';

import users from './card_config/users';
import support from './card_config/support';
import reseller from './card_config/reseller';
import rmc from './card_config/rmc';
import courses from './card_config/courses';
import conferences from './card_config/conferences';
import components from './card_config/components';
import certifications from './card_config/certifications';
import reviews from './card_config/reviews';
import plans from './card_config/payment_plans';
import salesTax from './card_config/sales_tax';
import transactions from './card_config/transactions';
import tools from './card_config/tools';
import organization from './card_config/organization';
import applications from './card_config/applications';
import providers from './card_config/content_providers';
import studyPlans from './card_config/study_plans';
import milestones from './card_config/milestones';
import tasks from './card_config/tasks';

export default [
    ...users,
    ...support,
    ...tasks,
    ...courses,
    ...conferences,
    ...components,
    ...certifications,
    ...reseller,
    ...rmc,
    ...reviews,
    ...plans,
    ...salesTax,
    ...transactions,
    ...tools,
    ...organization,
    ...applications,
    ...providers,
    ...studyPlans,
    ...milestones,
    {
        pathId: 'cus',
        component: 'user-settings',
        title: 'User Settings',
        icon: 'fa-user-cog',
        size: 'md', //sm, md, lg, xl
    },
    {
        pathId: 'test',
        component: 'test',
        title: 'Test',
        icon: 'fa-user-cog',
        size: 'full', //sm, md, lg, xl
    },

    {
        pathId: 'ml',
        component: 'media-library',
        title: 'Media Library',
        icon: 'fa-photo-film-music',
        size: 'full', //sm, md, lg, xl
    },

    {
        pathId: 'forecast-report',
        component: 'forecast-report',
        title: 'Payment Plan Forecast',
        icon: 'fa-circle-dollar',
        size: 'sm', //sm, md, lg, xl
    },

    // {
    //     pathId: 'enrollment-report',
    //     component: 'enrollment-report',
    //     title: 'Enrollment Report',
    //     icon: 'fa-circle-dollar',
    //     size: 'sm', //sm, md, lg, xl
    // },

    {
        pathId: 'reports',
        component: 'reports',
        title: 'Reports',
        icon: 'fa-chart-line',
        size: 'sm', //sm, md, lg, xl
    },
    {
        pathId: 'act',
        component: 'activity',
        title: 'Activity',
        icon: 'fa-users-viewfinder',
        size: 'xl', //sm, md, lg, xl
    },
];

Vue.component('user-settings', () => import('@/cards/settings/UserSettings'));
Vue.component('test', () => import('@/cards/Test'));
Vue.component('media-library', () => import('@/cards/media_library/Library'));
Vue.component('forecast-report', () => import('@/cards/reports/ForecastReport'));
Vue.component('enrollment-report', () => import('@/cards/reports/EnrollmentReport'));
Vue.component('reports', () => import('@/cards/reports/Reports'));
Vue.component('activity', () => import('@/cards/activity/Activity'));
